export default __webpack_public_path__ + "static/media/T16.144eb34d.png";